import { useState, useRef, useEffect } from 'react';
import useApi from "./useApi";

function useLaborCost () {
    const [laborCost, setLaborCost] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const laborCostApi = useApi('laborcost/EstimateLaborBudget');
    const laborCostLoad = useRef(true);

    useEffect(() => {
        if (laborCostLoad.current) {
            laborCostLoad.current = false;
            return;
        }

        setLaborCost(laborCostApi.data);
        setLoading(laborCostApi.loading);
        setError(laborCostApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [laborCostApi]);

    const estimateLaborBudget = async (countryId, zipCode, materialList) => {
        setLoading(true);
        laborCostApi.jsonPost({
            countryId: countryId,
            zipCode: zipCode,
            laborBadgetEstimationDetails: materialList
        });
    }

    return {
        laborCost,
        error,
        loading,
        estimateLaborBudget
    };
}

export default useLaborCost;